export default __webpack_public_path__ + "static/media/logo-transparent.0149cf3b.png";